export const formatMoney = (amount, addSign = true) => {
    if (amount == null) {
      return '';
    }

    let [temp, decimal] = amount.toString().split('.');
    if (decimal && decimal.length < 3) {
      decimal = decimal + '0';
    }
    if (!decimal) {
      decimal = '00';
    }
    let amountStr = temp
      .toString()
      .split(/(?=(?:\d{3})+(?:\.|$))/g)
      .join(',');

    amountStr = `${amountStr}.${decimal.substr(0, 2)}`;
    return addSign !== false ? `₦${amountStr}` : amountStr;
}